import React from 'react'

export default function StockInListHeaderStyle({signed_in}) {
  // let tb_buttons_display = null
  // if (signed_in !== 'admin') tb_buttons_display = { stockin_add_new: (signed_in.user_access.stockin_add_new) ? 'block' : 'none' }
  // else tb_buttons_display = { stockin_add_new: 'block' }
  let tb_buttons_display = null
  if (signed_in !== 'admin') tb_buttons_display = { stockin_fc: (signed_in.user_access.stockin_fc) ? 'block' : 'none' }
  else tb_buttons_display = { stockin_fc: 'block' }

  return (
    <React.Fragment>
      <style jsx='true'>
      {`
        /* DON'T DELETE FOR REFERENCE
        #refresh-list:hover .tooltip-text { left: 0%; }
        #refresh-list:hover .tooltip-text::after { left: 30%; }
        #settings:hover .tooltip-text { left: 20.8%; }
        #stock-in:hover .tooltip-text { left: 39.5%; }
        #batch-delete:hover .tooltip-text { left: 49%; }
        #batch-delete:hover .tooltip-text::after { left: 75%; }
        */

        /* ROOT CONTAINER */
        #stockin-list-toolbar {
          display: flex;
          padding: 5px 0;
        }
        /* ROOT CONTAINER END */

        /* Show or hide these toolbar buttons */
        #stock-in, #batch-delete { display: ${tb_buttons_display.stockin_fc}; }

        /* TRANSACTION TYPE CONTAINER */
          #transaction-type-outer-container {
            flex: 1;
            display: flex;
            align-items: center;
          }
          #transaction-type-inner-container {
            display: flex;
            border: 1px solid grey;
            margin: auto;
            border-radius: 30px;
          }
          #transaction-type-inner-container button {
            margin: auto;
          }
          .transaction-type-btn-active {
            background-color: rgba(82, 91, 91, 1) !important;
            color: white !important;
          }
          #posted-btn {
            border-top-left-radius: 30px;
            border-bottom-left-radius: 30px;
            background-color: rgba(82, 91, 91, 0.7);
            color: lightgrey;
            outline: none;
          }
          #returned-btn {
            border-top-right-radius: 30px;
            border-bottom-right-radius: 30px;
            background-color: rgba(82, 91, 91, 0.7);
            color: lightgrey;
            outline: none;
          }
          #returned-btn:focus, #returned-btn:hover,
          #posted-btn:focus, #posted-btn:hover {
            background-color: rgba(82, 91, 91, 1);
            color: white;
          }
        /* TRANSACTION TYPE CONTAINER END */
      `}
      </style>
    </React.Fragment>
  )
}
